import {
  ChevronLeft, Hand, Zap, PersonStanding, Gauge, Hourglass, EyeOff, Eye,
  RefreshCw, ArrowLeftRight, Maximize2, Settings, Target, Car, Square,
  Glasses, RotateCw, Shuffle, TrendingUp, Power, AlertTriangle, Rocket, MinusCircle,
} from "lucide-react";

// Colour palette matching the real DriveAssure app screens.
const C = {
  pink: "#E8368F",
  green: "#16A34A",
  teal: "#14A0A8",
  orange: "#E8890C",
  red: "#E23B36",
  blue: "#2563EB",
  brown: "#8A4B1A",
  purple: "#7C3AED",
};

// The exact 24 "Mark an Identified Error" categories from the app (page 1).
export const ERROR_CATALOG = [
  { code: "NP2L", label: "Not as Practicable to…", full: "Not as Practicable to the Left", cat: "Positioning", color: C.pink, Icon: ChevronLeft },
  { code: "NSAS", label: "Not Stopping at Stop Sign", full: "Not Stopping at Stop Sign", cat: "Signage", color: C.green, Icon: Hand },
  { code: "F2I", label: "Failure to Indicate", full: "Failure to Indicate", cat: "Signalling", color: C.teal, Icon: Zap },
  { code: "NGW2P", label: "Not Giving Way to a Pedestrian", full: "Not Giving Way to a Pedestrian", cat: "Give way", color: C.orange, Icon: PersonStanding },
  { code: "SPEED", label: "Exceeding Speed Limit", full: "Exceeding Speed Limit", cat: "Speed", color: C.red, Icon: Gauge },
  { code: "SLOW", label: "Driving Too Slowly / Obstr…", full: "Driving Too Slowly", cat: "Speed", color: C.red, Icon: Hourglass },
  { code: "FMO", label: "Failure to Maintain Obse…", full: "Failure to Maintain Observation", cat: "Observation", color: C.blue, Icon: EyeOff },
  { code: "HC", label: "Missed Head Check / Blind…", full: "Missed Head Check", cat: "Observation", color: C.blue, Icon: Eye },
  { code: "FGW", label: "Failure to Give Way", full: "Failure to Give Way", cat: "Give way", color: C.orange, Icon: Hand },
  { code: "RAB", label: "Roundabout Error", full: "Roundabout Error", cat: "Junctions", color: C.orange, Icon: RefreshCw },
  { code: "LANE", label: "Poor Lane Position", full: "Poor Lane Position", cat: "Positioning", color: C.pink, Icon: ArrowLeftRight },
  { code: "GAP", label: "Following Too Closely", full: "Following Too Closely", cat: "Spacing", color: C.pink, Icon: Maximize2 },
  { code: "CLUTCH", label: "Clutch / Gear Control", full: "Clutch / Gear Control", cat: "Control", color: C.brown, Icon: Settings },
  { code: "STEER", label: "Steering Control", full: "Steering Control", cat: "Control", color: C.brown, Icon: Target },
  { code: "PARK", label: "Parking / Reversing Error", full: "Parking / Reversing Error", cat: "Manoeuvres", color: C.purple, Icon: Car },
  { code: "REDLIGHT", label: "Disobeying Traffic Light", full: "Disobeying Traffic Light", cat: "Signage", color: C.green, Icon: Square },
  { code: "MIRROR", label: "Missed Mirror Check", full: "Missed Mirror Check", cat: "Observation", color: C.blue, Icon: Glasses },
  { code: "UTURN", label: "Illegal / Unsafe U-Turn", full: "Illegal / Unsafe U-Turn", cat: "Manoeuvres", color: C.purple, Icon: RotateCw },
  { code: "3PT", label: "Three-Point Turn Error", full: "Three-Point Turn Error", cat: "Manoeuvres", color: C.purple, Icon: Shuffle },
  { code: "HILL", label: "Hill Start Roll-Back", full: "Hill Start Roll-Back", cat: "Control", color: C.brown, Icon: TrendingUp },
  { code: "STALL", label: "Stalling the Vehicle", full: "Stalling the Vehicle", cat: "Control", color: C.brown, Icon: Power },
  { code: "BRAKE", label: "Harsh / Late Braking", full: "Harsh / Late Braking", cat: "Control", color: C.brown, Icon: AlertTriangle },
  { code: "ACCEL", label: "Harsh Acceleration", full: "Harsh Acceleration", cat: "Control", color: C.brown, Icon: Rocket },
  { code: "KERB", label: "Striking / Mounting Kerb", full: "Striking / Mounting Kerb", cat: "Positioning", color: C.pink, Icon: MinusCircle },
];

export const findError = (code) => ERROR_CATALOG.find((e) => e.code === code);
